import script from "./InputAmount.vue?vue&type=script&setup=true&lang=js"
export * from "./InputAmount.vue?vue&type=script&setup=true&lang=js"

import "./InputAmount.vue?vue&type=style&index=0&id=0a999b09&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a999b09"]])

export default __exports__